import { render } from "./LanguageSelection.vue?vue&type=template&id=404776a7&scoped=true"
import script from "./LanguageSelection.vue?vue&type=script&lang=js"
export * from "./LanguageSelection.vue?vue&type=script&lang=js"

import "./LanguageSelection.vue?vue&type=style&index=0&id=404776a7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-404776a7"]])

export default __exports__